import { useSelector } from 'react-redux';

import { getClientFeatureFlagSelector } from '@app/reducers/app';
import type { RootState } from '@app/reducers';

const useClientFeatureFlag = (featureFlagName: string) =>
  useSelector((state: RootState) => getClientFeatureFlagSelector(state, featureFlagName));

export default useClientFeatureFlag;
